import type { HTMLAttributes, ReactNode } from 'react';

export interface KbdProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
}

/**
 * Keyboard key badge — mono, 1px border, `--surface` background, 11px.
 * Matches dashboard.html `kbd` element.
 */
export function Kbd({ children, className, ...rest }: KbdProps) {
  const cls = ['pn-kbd', className].filter(Boolean).join(' ');
  return (
    <kbd className={cls} {...rest}>
      {children}
    </kbd>
  );
}
